import { useState } from 'react';

import { Button } from '@flipster/react/design-system';
import { css } from '@flipster/styled-system/css';
import { hstack } from '@flipster/styled-system/patterns';
import segment from '@flipster/utils/segment';
import { MainEvent } from '@flipster/utils/segment/events/main';

import useClickSignUp from '@web/app/[locale]/(web)/_main-page/hooks/useClickSignUp';

const EmailTextFieldCTA = () => {
  const [email, setEmail] = useState<string>('');

  const onClickSignUp = useClickSignUp();
  const onSubmit = () => {
    segment.track(MainEvent.MainPageGetStartedClick);
    onClickSignUp({ email });
  };

  return (
    <>
      {/* > mobile */}
      <div className={hstack({ gap: 8, display: { base: 'flex', tabletDown: 'none' } })}>
        <input
          type='text'
          value={email}
          onChange={(e) => setEmail(e.currentTarget.value)}
          onClick={() => {
            segment.track(MainEvent.MainPageSignUpEmailClick);
          }}
          placeholder='name@flipster.io'
          className={css({
            textStyle: 'Text/L/Regular',
            color: 'content.default.level-4',
            h: 48,
            px: 20,
            flex: 1,
            rounded: 4,
            borderWidth: 1,
            borderColor: 'border.default.level-3',
            borderStyle: 'solid',
            '&::placeholder': {
              textStyle: 'Text/L/Strong',
            },
          })}
        />
        <Button hierarchy='primary' color='accent' size='large' onClick={onSubmit} label='Sign up' css={{ w: 100 }} />
      </div>
      {/* = mobile */}
      <Button
        hierarchy='primary'
        color='accent'
        size='large'
        as='a'
        href='/signup'
        label='Sign up'
        css={{ display: { tablet: 'none' }, w: '100%' }}
      />
    </>
  );
};

export default EmailTextFieldCTA;
